
define('text!views/pages/games/all.html',[],function () { return '<div class="page" data-bind="with: allGamesCategory">\n\n    {{#compose: \'gamesHeader\' }}{{/compose}}\n\n    <div data-bind="gamesList: { games: games }"></div>\n\n</div>';});

